<template>
  <font-awesome-icon
    icon="envelope"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

library.add(faEnvelope)

export default {
  name: 'CoozzyEnvelopeIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
